
import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Header from '../../../../../Components/Header/Header'
import Sidebar from '../../../../../Components/Sidebar/Sidebar'


export default function CommonWTPAssignedMaintainanceWorkDataPage() {

    // const [DeletePopupShow, setDeletePopupShow] = useState()
    // const [WTPQuantityOfWaterPagePopupShow, setWTPQuantityOfWaterPagePopupShow] = useState(0)

    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [searchParams] = useSearchParams()
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashProjectTypeId = searchParams.get("DashProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")
    let ScreenName = searchParams.get("ScreenName")


    const [WardName, setWardName] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const [Location, setLocation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    // const [PumpingStation, setPumpingStation] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    // const handleAddOnClick = () => {
    //     console.log("add")
    //     setWTPQuantityOfWaterPagePopupShow(true)
    // }

    // const handleEditOnClick = (item) => {
    //     setWTPQuantityOfWaterPagePopupShow(true)
    //     setapiFlag('Update')
    //     setrowData()
    // }

    // const handleOnCloseClick = () => {
    //     setWTPQuantityOfWaterPagePopupShow(false)
    // }

    // const handleIsSearch = () => {
    //     setIsSearch(!IsSearch)
    //     setCurrentPage(0)
    // }

    // const handleClear = () => {
    //     setCurrentPage(0)
    //     setIsClear(!IsClear)
    //     setWorkName('')
    // }

    // const handleClear = () => {
    //     // setCurrentPage(0)
    //     // setIsClear(!IsClear)

    //     setWardName({
    //         ...WardName,
    //         ID: 0,
    //         Label: 'Select...',
    //     })
    //     // console.log("call")
    // }

    return (
        <div>
            <Header
                MLable={MLable}
                HMonth={HMonth}
                YLable={YLable}
                HYear={HYear}
                HWard={HWard}
                WLable={WLable}
                flag='Screen'
                DashboardName={DashboardName} />
            <div className="wrapper">
                <Sidebar ProjectTypeId={ProjectTypeId}
                    DashProjectTypeId={DashProjectTypeId} />
                <div className="content">
                    {/* <!-- [ breadcrumb ] start --> */}
                    {/* <!-- [ Main Content ] start --> */}
                    <div className='data_mob'>
                        <div className="row m-1 pb-4 master_border">
                            <div className='mt-2'>
                                <h5>{ScreenName}</h5>
                                <div className="float-end butt">
                                    {/* <i class="fa-solid fa-plus add_btn" style={{ color: "#010813", fontSize: '17px' }}><span className="ml-2">Add</span></i> */}
                                    <button type="button" className="btn btn-primary float-end ml-1">Export</button>
                                    {/* 
                                        <SeweragePipelinePopup
                                            open={SewerageMasterPopupShow}
                                        /> */}
                                    {/* <i className="fa-solid fa-plus float-end btn btn-secondary"
                                        style={{ color: "white" }}
                                        // onClick={handleAddOnClick}
                                    >
                                        <text className="ml-2 poppins">Add</text>
                                    </i> */}

                                </div>
                            </div>
                            <div className="row m-0 pt-1">
                                <div className="col-12 py-0 rounded rounded-2 shadow"
                                    style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                    <div className="col-12">
                                        <div className="row py-1 rounded2">

                                            <div className="col-12 col-md-6 col-lg-2 ">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"> <b>From Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                    // value={FromDate}
                                                    // onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-12 col-md-6 col-lg-2 ">
                                                <div className="form-group">
                                                    <label className="d-block" htmlFor="NameofDepartment"> <b>To Date </b></label>
                                                    <input type="date"
                                                        className="form-control"
                                                        id="FromDate"
                                                    // value={FromDate}
                                                    // onChange={(e) => (setFromDate(e.target.value), setToDate(''))}
                                                    />

                                                </div>
                                            </div>

                                            <div className="col-lg-2 col-md-6">
                                                <label for=""><b>Ward Name </b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: WardName.ID, label: WardName.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setWardName({ ...WardName, ID: e.value, Label: e.label })
                                                            :
                                                            setWardName({ ...WardName, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={WardName.DDL}
                                                />

                                            </div>

                                            <div className="col-lg-3 col-md-6">
                                                <label for=""><b>Location </b></label>
                                                <Select
                                                    // isClearable
                                                    // isRtl={isRtl}
                                                    // className="ddl_width"
                                                    isSearchable
                                                    maxMenuHeight={150}
                                                    value={{ value: Location.ID, label: Location.Label }}
                                                    onChange={(e) => {
                                                        e ?
                                                            setLocation({ ...Location, ID: e.value, Label: e.label })
                                                            :
                                                            setLocation({ ...Location, ID: 0, Label: "Select..." })

                                                    }}
                                                    options={Location.DDL}
                                                />

                                            </div>

                                            <div className="col-12 col-lg-3 col-md-4 mt-lg-4 mt-md-4 d-md-flex " >
                                                <button type="button"
                                                    className="btn-clear btn btn-primary mx-2"
                                                    // onClick={handleSearch}
                                                >
                                                    Search</button>
                                                <button type="button"
                                                    className="btn btn-outline-danger"
                                                    // onClick={handleClear}
                                                >
                                                    Clear</button>
                                            </div>

                                        </div>
                                        <div className="row mob_table table-responsive pt-2">

                                            <table id="totalordergenerated"
                                                cellPadding="0"
                                                cellSpacing="0"
                                                border="0"
                                                className="table table-bordered">

                                                <thead>
                                                    <tr>
                                                        <th className="sr_no_col">Sr No.</th>
                                                        <th>Work Assign Date</th>
                                                        <th>Work Done Date</th>
                                                        <th>Work Name</th>
                                                        <th>Before Photo</th>
                                                        <th>After Photo</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td style={{ textAlign: "center" }}>1</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        {/* <td>
                                                            <span>
                                                                <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                    style={{ cursor: 'pointer' }}
                                                                    onClick={() => handleEditOnClick()}
                                                                >
                                                                </i>
                                                            </span>
                                                            <span>
                                                                <DeletePopup
                                                                    open={DeletePopupShow}
                                                                // item={item}
                                                                // handleDeleteApi={handleDeleteApi}
                                                                />
                                                            </span>
                                                        </td> */}
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {/* {
                    WTPQuantityOfWaterPagePopupShow ?
                        <WTPQuantityOfWaterPagePopup
                            open={WTPQuantityOfWaterPagePopupShow}
                            // handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                        // Flag={apiFlag}
                        // rowData={rowData}
                        />
                        : <></>
                } */}

            </div>
        </div>



    )
}